import { DashboardIconWave } from '@hr/common/icons'
import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPersons } from '../../actions/persons/personsgetall'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { jsError, localized } from '../../common/utils'
import { personsSelector } from '../../reducers'

export function EndingEmployments() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const persons = useSelector(personsSelector)

	const startKey = 'endingEmployments_startDate'
	const endKey = 'endingEmployments_endDate'

	const [startDate, setStartDate] = useState(() => {
		return (
			localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0]
		)
	})

	const [endDate, setEndDate] = useState(() => {
		return (
			localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0]
		)
	})

	const [data, setData] = useState()

	const endCodeLabels = {
		1: t('EndCode1', 'Oma irtisanoutuminen'),
		2: t('EndCode2', 'Muu syy'),
		3: t('EndCode3', 'Henkilöstä riippuva syy'),
		4: t('EndCode4', 'Tuotannolliset ja taloudelliset syyt'),
		5: t('EndCode5', 'Työsuhteen päättyminen yhteisestä sopimuksesta'),
		6: t('EndCode6', 'Eläkkeelle siirtyminen'),
		7: t('EndCode7', 'Määräaikaisen työsuhteen päättyminen'),
		10: t('EndCode10', 'Kunta-ala: Eronnut, työ päättynyt'),
		101: t('EndCode101', 'Valtio: Eronnut, työ päättynyt'),
	}

	useEffect(() => {
		const fetchPersons = async () => {
			try {
				dispatch(getAllPersons())
			} catch (err) {
				jsError(err)
			}
		}

		fetchPersons()
	}, [dispatch])

	useEffect(() => {
		if (!persons) return

		const start = new Date(startDate)
		start.setHours(0, 0, 0, 0)

		const end = new Date(endDate)
		end.setHours(23, 59, 59, 999)

		const filteredPersons = persons.filter((person) => {
			const employmentEnd = person.employmentDetails?.endDate

			if (!employmentEnd) {
				return false
			}

			const employmentEndDate = new Date(employmentEnd)

			return employmentEndDate >= start && employmentEndDate <= end
		})

		const tableData = filteredPersons
			.map((person) => ({
				personName: person.name,
				profession: person.employmentDetails?.profession,
				endDate: new Date(person.employmentDetails.endDate),
				endCode: person.employmentDetails?.endCode,
				endInfo: person.employmentDetails?.endInfo,
			}))
			.sort((a, b) => a.endDate - b.endDate)

		setData(tableData)
	}, [persons, startDate, endDate])

	const handleStartDateChange = (val) => {
		setStartDate(val)
		localStorage.setItem(startKey, val)
	}

	const handleEndDateChange = (val) => {
		setEndDate(val)
		localStorage.setItem(endKey, val)
	}

	if (!data) {
		return <LoadingContainer />
	}

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
					}}
				>
					<span className="starting-employments-icon">
						<DashboardIconWave />
					</span>

					<h4 style={{ margin: 0 }}>{t('EndingEmployments', 'Päättyvät työsuhteet')}</h4>
				</div>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => handleStartDateChange(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => handleEndDateChange(e.target.value)} />
				</div>
			</div>

			{data.length ? (
				<div style={{ overflowX: 'auto' }}>
					<Table>
						<thead>
							<tr>
								<th>{t('Person', 'Henkilö')}</th>
								<th>{t('JobTitle', 'Tehtävänimike')}</th>
								<th>{t('Ending', 'Päättyy')}</th>
								<th>{t('EmploymentEndCode', 'Päättymisen syy')}</th>
								<th>{t('MessageToPayroll', 'Viesti palkanlaskentaan')}</th>
							</tr>
						</thead>

						<tbody>
							{data.map((row) => (
								<tr key={row.personName}>
									<td>{row.personName}</td>
									<td>{row.profession}</td>
									<td>{row.endDate.toLocaleDateString(localized.resolvedLanguage)}</td>
									<td>{endCodeLabels[row.endCode] || row.endCode}</td>
									<td>{row.endInfo}</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			) : (
				<p>({t('NoEndingEmployments', 'Ei päättyviä työsuhteita')})</p>
			)}
		</>
	)
}
